import { Theme, WithStyles } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { TableCellProps } from "@material-ui/core/TableCell";
import TableCell from "@material-ui/core/TableCell";
import React from "react";
import { FindAllParams, LocalFindAllParams } from "../../dataAccess/DataSource";
import { Schema } from "../../dataAccess/Schema";
import { DynamicField, Field, FunWithCtxOr } from "../../dataAccess/Field";
import { I18n } from "../../index";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      position: "relative"
    },
    table: {
      tableLayout: "auto"
    },
    buttonsColumn: {
      width: "auto"
    },
    buttonColumn: {
      width: "10px"
    },
    inlineButton: {
      float: "right",
      marginRight: "5px"
    },
    "& .menuItem": {
      display: "inline-block"
    },
    checkboxCell: {
      width: "1px",
      height: "40px"
    },
    body: {},
    cell: {
      maxWidth: "80px",
      minWidth: "20px",
      overflow: "hidden"
    },
    draggedCell: {
      width: "130px",
      overflow: "hidden"
    },
    row: {
      backgroundColor: "rgba(80,80,80, 0.2) !important"
    },
    dragging: {
      background: "#fff",
      display: "table",
      tableLayout: "fixed"
    },
    header: {
      height: "40px",
      paddingBottom: "5px",
      textAlign: "center"
    },
    menuCell: {
      alignItems: "center"
    },
    toolbar: {
      width: "40px",
      left: -20
    },
    footer: {
      display: "flex",
      alignItems: "center",
      flex: "1 0",
      margin: "12px"
    },
    footerContentTotalPages: { marginLeft: "auto" },
    footerContentPageSizeRoot: {
      padding: "10px 24px 10px 10px"
    },
    footerContentPageSizeSelector: {
      marginLeft: theme.spacing(1) * 2
    }
  });

export interface DataTableProps extends WithStyles<typeof styles> {
  columns: Columns;
  data: any[];
  rowButtons?: (row: any, key: string, close: () => void) => React.Component;
  toolbarButtons?: (close: () => void) => React.Component;
  params: LocalFindAllParams;
  selected: any[];
  total: number;
  hidePageable?: boolean;
  alignCellText?: string;
  hideTotalPages?: boolean;
  inlineRowButtons?: boolean;
  pageSizeOptions?: number[];
  tableBodyComponent?: React.ComponentType;
  tableRowComponent?: React.ComponentType;
  // actions
  updateRows: (ids: any, data: {}) => void;
  search: (params: FindAllParams) => void;
  toggleSelect: (multiSelect: boolean, id: any) => void;
  toggleSelectAll: () => void;
  disableCheckboxes?: false;
  i18n: I18n;
}

export class Columns extends Schema<DynamicColumn, Column> {}

export interface Column extends Field {
  width?: string;
  filter?: false | OperationOptions;
  sort?: false | OperationOptions;
}

export type DynamicColumn = DynamicField &
  {
    [P in keyof Column]?: FunWithCtxOr<Column[P]>;
  };

export interface OperationOptions {
  field: string;
}

export const Cell = withStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        padding: theme.spacing(1),
        paddingLeft: theme.spacing(1) * 2
      }
    }),
  { withTheme: true }
)((props: TableCellProps) => {
  return <TableCell {...props} />;
});

export const FilterCell = withStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        padding: theme.spacing(1)
      }
    }),
  { withTheme: true }
)((props: TableCellProps) => {
  return <TableCell {...props} />;
});

export const EmptyCell = ({ children, ...props }: TableCellProps) => (
  <TableCell {...props}>&nbsp;</TableCell>
);
